/* eslint max-len: 0 */

import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

type Props = {
  readonly company?: string;
  readonly fromDashboard?: string;
};

const HelpAdminInboundNumbers = (props: Props) => {
  return (
    <div style={{ padding: 5 }}>
      <Typography variant="body1" style={{ marginTop: 15, marginBottom: 10 }}>
        {props.fromDashboard ? (
          <Button component={Link} to="/administration/inboundNumbers" size="small" color="secondary">
            <FormattedMessage id="nav.administration.inbound.numbers" />
          </Button>
        ) : undefined}
      </Typography>
      <div style={{ paddingLeft: 15, paddingRight: 15 }}>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="help.administration.inboundNumbers.1" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.inboundNumbers.2" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.inboundNumbers.3" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.inboundNumbers.4" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.inboundNumbers.5" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.inboundNumbers.6" />
        </Typography>
        <p></p>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="administration.inboundNumbers.forwarding.type" />
        </Typography>
        <p></p>
        <div style={{ paddingLeft: 15, paddingRight: 15 }}>
          <Typography variant="body2" align="justify">
            <FormattedMessage id="help.administration.inboundNumbers.7" />
          </Typography>
          <p></p>
          <Typography variant="body2" align="justify">
            <FormattedMessage id="help.administration.inboundNumbers.8" />
          </Typography>
          <p></p>
          <Typography variant="body2" align="justify">
            <FormattedMessage id="help.administration.inboundNumbers.9" />
          </Typography>
          <p></p>
        </div>
      </div>
    </div>
  );
};

export default HelpAdminInboundNumbers;
